import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ClientUser, FullClientUser } from 'src/models/ClientUser';
import { ApiService } from '../api.service';
import { LocalitiAuthService } from '../localiti-auth.service';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {
  public signUpForm: FormGroup|null = null ;

  constructor(private auth: LocalitiAuthService, private api: ApiService) { }
  async doSignUp(form: any) {
    const newClient : ClientUser = {
      id: undefined,
      name: form.name,
      phone: form.phone,
      address1: form.address1,
      address2: form.address2,
      address3: form.address3,
      city: form.city,
      state: form.state,
      postal: form.postal,
      country: form.country,
      email: form.email
    };
    this.isLoading = true;
    try {
      const ret = await this.api.createClientUser(newClient);
      console.log(ret);
      await this.auth.forceReauth();
    } catch(e) {
      console.error(e);
    } finally {
      this.isLoading = false;
    }
  }
  public hasError = (controlName: string, errorName: string) =>{
    if (!this.signUpForm) {
      return false;
    }
    if (!this.signUpForm.contains(controlName)) {
      return false;
    }

    return this.signUpForm.controls[controlName].hasError(errorName);
  }
  isLoading = true;
  async ngOnInit() {
    this.isLoading = true;
    try {
      console.log("start get user");
      if (!this.auth.user) {
        console.error("it's null");
      }
      const usr = await this.auth.user;
      console.log("done get user: " + JSON.stringify(usr));
      const clientUser : FullClientUser = (usr?usr.clientUser:null) || <FullClientUser>{};
      this.signUpForm = new FormGroup({
        name: new FormControl(clientUser.name||(usr?usr.displayName:''), [Validators.required, Validators.maxLength(100)]),
        phone: new FormControl(clientUser.phone||(usr?usr.phoneNumber:''), [Validators.required, Validators.pattern("[0-9]{10}")]),
        email: new FormControl(clientUser.email||(usr?usr.email:''), [Validators.required, Validators.email]),
        address1: new FormControl(clientUser.address1||'', [Validators.required]),
        address2: new FormControl(clientUser.address2||'', []),
        address3: new FormControl(clientUser.address3||'', []),
        city: new FormControl(clientUser.city||'', [Validators.required]),
        state: new FormControl(clientUser.state||'', [Validators.required]),
        postal: new FormControl(clientUser.postal||'', [Validators.required]),
        country: new FormControl(clientUser.country||'', [Validators.required])
      });
    } catch (e) {
      console.error("error loading user");
      console.error(e);
    } finally {
      this.isLoading = false;
    }
  }

}
